import { firstRechargeStagedApi } from "@/api/firstRechargeStagedApi";
import { useHomeDisplayStore } from "@/modules/homeDisplay/stores";
import {
  FIRST_RECHARGE_STAGED_PENDING_CLAIM_EVENT,
  SESSION_PENDING_STAGED_FIRST_DEPOSIT_CLAIM,
  shouldSetPendingStagedClaimAfterDeposit,
} from "@/constants/firstRechargeStagedSession";
import type { PendingStagedClaimGateOptions } from "@/constants/firstRechargeStagedSession";

/**
 * 充值成功路径：与首页自动领取弹窗内逻辑一致，多次拉取 snapshot，
 * 避免接口晚于「关收银台 / 返回」才写出可领取状态导致不打 session 标。
 */
export async function syncAndMarkPendingStagedClaimAfterDeposit(
  opts?: PendingStagedClaimGateOptions
): Promise<void> {
  const patch = useHomeDisplayStore.getState().patchFirstRechargeStaged;
  let staged = useHomeDisplayStore.getState().data?.firstRechargeStaged;

  for (let attempt = 0; attempt < 5; attempt++) {
    if (shouldSetPendingStagedClaimAfterDeposit(staged, opts)) {
      sessionStorage.setItem(SESSION_PENDING_STAGED_FIRST_DEPOSIT_CLAIM, "1");
      window.dispatchEvent(
        new CustomEvent(FIRST_RECHARGE_STAGED_PENDING_CLAIM_EVENT)
      );
      return;
    }
    if (attempt > 0) {
      await new Promise<void>(resolve => {
        window.setTimeout(resolve, 400);
      });
    }
    try {
      const remote = await firstRechargeStagedApi.fetchSnapshot();
      patch(remote);
      staged = remote;
    } catch {
      /* 保持当前 staged，下一轮再试 */
    }
  }
}
